<template>
    <div class="template-container" v-if="content.title&&content.items&&content.items.length">
        <div class="template-title">{{content.title}}</div>
        <div class="items">
            <div class="item" v-for="item in content.items" @click="itemClick(item)" :class="$router.currentRoute.query.type==''">
                <span class="one one-filetype-folder"></span>
                <span class="name">{{item.itemName}}</span>
                <span class="desc">{{item.itemDesc}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TemplateContainer",
        props: { content: Object},
        methods:{
            itemClick(item){
                if(item.href){
                    window.open(item.href)
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .template-container {
        width: 727px;
        background: #FFFFFF;
        box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.05);
        border-radius: 3px;
        padding: 19px 24px;
        .template-title{
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            color: #444444;
        }
        .items{
            margin-top: 20px;
            cursor: pointer;
            .item{
                &:hover{
                   .one,.name{
                       color: #ED6C00;
                   }
                }
            }
            .one{
                font-size: 16px;
                line-height: 17px;
                color: #B1B1B1;
                margin-right: 12px;
                position: relative;
                top:2px
            }
            .name{
                font-weight: 500;
                font-size: 14px;
                line-height: 20px;
                color: #444444;
                margin-right: 16px;
            }
            .desc{
                font-size: 12px;
                line-height: 17px;
                color: #444444;

            }

        }
    }
</style>